import { captureException } from "@sentry/react";
import { useEffect } from "react";
import useSWR from "swr";

import { swrFetcher } from "../../utils/swr";

export const useScnSolAPY = () => {
  const { data, error } = useSWR("https://api.socean.fi/v2/stake/apy", swrFetcher, {
    revalidateOnFocus: false,
  });

  useEffect(() => {
    if (error) {
      console.error("Unexpected failure to retrieve Socean scnSOL APY:", error);
      captureException(error);
      return undefined;
    }
  }, [error]);

  return data;
};
